import React from "react";
import ArApWriteOffsGenericSkeleton from "./ArApWriteOffsGenericSkeleton";

function ArApWriteOffsDetailSkeleton() {
  return (
    <>
      <ArApWriteOffsGenericSkeleton />
    </>
  );
}

export default ArApWriteOffsDetailSkeleton;
